module.exports = __webpack_public_path__ + "img/login-overlay-bg.eeea1fc5.png";